export default __webpack_public_path__ + "static/media/factory.189247a0.svg";